//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
import { calcPayAll, calcPayPartition } from './utils'
export default {
    mixins: [
        mixin
    ],
    data () {
        return {
            params: {},
            result: {
                last_month_pay: '',
                paid_interest: '',
                paid_base: '',
                save_interest: '',
                prepayment_time: '',
                decrease_month: {
                    month_pay: '',
                    save_interest: '',
                    last_time: ''
                },
                decrease_pay: {
                    month_pay: '',
                    save_interest: '',
                    last_time: ''
                }
            }
        }
    },
    computed: {
        show_all_clear () {
            return this.params.prepayment_type === '一次性还清'
        }
    },
    created () {
        const { params } = this.$route.params
        if (!params) {
            this.$router.replace({
                name: 'prepayment_calc'
            })
        } else {
            this.params = JSON.parse(params)
            this.compute()
        }
    },
    methods: {
        compute () {
            if (this.show_all_clear) {
                this.result = calcPayAll(this.params)
            } else {
                this.result = calcPayPartition(this.params)
            }
        }
    },
    components: {
    }
}
